import React, { useEffect, useState } from 'react';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { DataTable, Card } from '../UI';

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData(`${Endpoints.TOP_RIDERS}?limit=20`)
      .then((r) => r.json())
      .then((res) => {
        const list = (res && res.data) || res || [];
        setRows(Array.isArray(list) ? list : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const columns = [
    { name: 'Rank', cell: (_, i) => i + 1, width: '80px' },
    { name: 'Name', selector: 'name' },
    { name: 'Phone', selector: 'phone' },
    { name: 'Completed jobs', selector: 'completed_jobs', sortable: true },
    {
      name: 'Reward pool',
      selector: 'reward_pool_cents',
      cell: (row) => `KES ${((row.reward_pool_cents || 0) / 100).toFixed(2)}`,
    },
    {
      name: 'Penalty debt',
      cell: (row) => `KES ${((row.penalty_debt_cents || 0) / 100).toFixed(2)}`,
    },
  ];

  return (
    <PageLayout title="Rider leaderboard">
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={rows}
          progressPending={loading}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
